module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/359.74ce0368.png";